// src/hooks/useServiceWorkerUpdate.ts
// Hook pour détecter et gérer les mises à jour du service worker

import { useState, useEffect } from 'react';

interface ServiceWorkerUpdateState {
  updateAvailable: boolean;
  registration: ServiceWorkerRegistration | null;
}

export const useServiceWorkerUpdate = (): ServiceWorkerUpdateState => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    // Écouter l'événement personnalisé déclenché par serviceWorkerRegistration
    const handleUpdateAvailable = (e: CustomEvent) => {
      const reg = e.detail as ServiceWorkerRegistration;
      setRegistration(reg);
      setUpdateAvailable(true);
    };

    window.addEventListener('sw-update-available', handleUpdateAvailable as EventListener);

    // Vérification périodique des mises à jour (toutes les 60 secondes)
    const checkInterval = setInterval(() => {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((reg) => {
          reg.update();
        });
      });
    }, 60000);

    return () => {
      window.removeEventListener('sw-update-available', handleUpdateAvailable as EventListener);
      clearInterval(checkInterval);
    };
  }, []);

  return { updateAvailable, registration };
};
